import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { LiaCookieBiteSolid } from 'react-icons/lia'

const CONSENT_KEY = 'cookie_consent_accepted'

export default function CookieConsent() {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        // localStorage me flag check karo — agar pehle accept ho chuka hai to kabhi mat dikhao
        try {
            if (!localStorage.getItem(CONSENT_KEY)) setVisible(true)
        } catch {
            // localStorage blocked (private mode etc.) — banner mat dikhao, crash na ho
        }
    }, [])

    const accept = () => {
        try {
            // 'true' save karte hi lifetime ke liye band — jab tak user browser data clear na kare
            localStorage.setItem(CONSENT_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }))
        } catch { /* ignore */ }
        setVisible(false)
    }

    if (!visible) return null

    return (
        <div
            role="dialog"
            aria-label="Cookie consent"
            className="fixed bottom-3 left-3 right-3 z-50 mx-auto max-w-xl animate-fade-up rounded-2xl border border-gray-100 bg-white/95 p-4 shadow-xl backdrop-blur-md sm:bottom-5 sm:flex sm:items-center sm:gap-4 sm:p-5"
        >
            <div className="flex items-start gap-3">
                <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-brand-50 text-brand-600">
                    <LiaCookieBiteSolid size={22} aria-hidden="true" />
                </span>
                <p className="text-xs leading-relaxed text-gray-600 sm:text-sm">
                    We use cookies to improve your experience and keep you signed in.
                    By continuing, you agree to our{' '}
                    <Link to="/privacy" className="font-medium text-brand-600 hover:text-brand-700 underline underline-offset-2">
                        Privacy Policy
                    </Link>.
                </p>
            </div>
            <div className="mt-3 flex justify-end sm:mt-0 sm:shrink-0">
                <button
                    type="button"
                    onClick={accept}
                    className="rounded-xl bg-gradient-to-b from-brand-400 to-brand-500 px-5 py-2 text-sm font-semibold text-white shadow-brand transition duration-300 hover:brightness-105 active:scale-95"
                >
                    Accept
                </button>
            </div>
        </div>
    )
}